import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable, map } from 'rxjs';

import { SKIP_AUTH } from '../auth/auth.context';
import type { ApiEnvelope } from '../http/api-envelope';
import type {
  BugReportRequest,
  FeedbackMessageRequest,
  LoginHelpRequest,
  NpsRatingRequest,
} from './support.models';

@Injectable()
export abstract class SupportApi {
  abstract submitLoginHelp(request: LoginHelpRequest): Observable<void>;
  abstract submitFeedbackMessage(request: FeedbackMessageRequest): Observable<void>;
  abstract submitBugReport(request: BugReportRequest): Observable<void>;
  abstract submitNpsRating(request: NpsRatingRequest): Observable<void>;
}

@Injectable()
export class HttpSupportApi extends SupportApi {
  private readonly http = inject(HttpClient);

  override submitLoginHelp(request: LoginHelpRequest): Observable<void> {
    return this.http
      .post<ApiEnvelope<{ id: string }>>('/feedback/message', request, { context: skipAuth() })
      .pipe(map(() => undefined));
  }

  override submitFeedbackMessage(request: FeedbackMessageRequest): Observable<void> {
    return this.http
      .post<ApiEnvelope<{ id: string }>>('/dashboard/feedback/message', request)
      .pipe(map(() => undefined));
  }

  override submitBugReport(request: BugReportRequest): Observable<void> {
    return this.http
      .post<ApiEnvelope<{ id: string }>>('/dashboard/feedback/bug', request)
      .pipe(map(() => undefined));
  }

  override submitNpsRating(request: NpsRatingRequest): Observable<void> {
    return this.http
      .post<ApiEnvelope<{ ok: boolean }>>('/dashboard/feedback/nps', request)
      .pipe(map(() => undefined));
  }
}

function skipAuth(): HttpContext {
  return new HttpContext().set(SKIP_AUTH, true);
}
